<template>
  <div>
    <div class="relative pt-44 pb-12 px-12 lg:px-16 xl:px-24 text-center">
      <div class="page-container">
        <div class="flex justify-center items-center flex-wrap">
          <div class="w-full pt-16 md:max-w-[70rem] mx-auto flex flex-col items-center">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>

</style>
